import { Link } from "react-router-dom";
import { Col, Row } from "../../../../ApiS/Grid-system/Grid-system";
import Title from "../../../Title/Title";
import { TbEdit, TbTrash } from "react-icons/tb";
import Accordion from "../../../Accordion/Accordion";
import { useDelete, useFetch } from "../../../../ApiS";
import Add from "../../../Buttons/Add";
import Loader from "../../../Loader";

export default function ProgramRule() {

    const { data , isLoading } = useFetch("admin/program-rules", "program-rules");
  console.log(data?.data?.data);

  let dataAll = data?.data?.data;

  const { deleteItem } = useDelete(
    () => {},
    () => {}
  );
  return  (
    <>
      <Row>
        <Col lg={4}>
          <Title title="قواعد البرنامج" />
        </Col>
      </Row>
    {isLoading && <Loader/>}
      <Row>
      <Col
            lg={12}
            md={10}
            sm={10}
            className="!px-4 !py-4"
          >
            {dataAll?.map((e: any) => (
              <Row>
                <Col lg={10} md={10} sm={10}>
                  <Accordion
                    name={e.title_ar}
                    Register={true}
                    className=" !bg-[#efc5e6] !py-3 !mt-4"
                    desc={e.description_ar}
                  />
                </Col>
                <Col lg={1} md={1} sm={1} className="flex items-center">
                  <TbTrash
                    size={30}
                    className="text-red-600 cursor-pointer mt-2"
                    onClick={() => deleteItem(`admin/program-rules/${e.id}`)}
                  />
                </Col>
                <Col lg={1} md={1} sm={1} className="flex items-center">
                  <Link to={`${e.id}/edit`}>
                    <TbEdit
                      size={30}
                      className="text-blue-600 cursor-pointer mt-2"
                    />
                  </Link>
                </Col>
              </Row>
            ))}

          </Col>
      </Row>
      <Add link="add" />
    </>
  );
}
